/**
 * Get List
 */
export const ORGANIZATION_LIST = "ORGANIZATION_LIST";
export const ORGANIZATION_LIST_SUCCESS = "ORGANIZATION_LIST_SUCCESS";
export const ORGANIZATION_LIST_FAILURE = "ORGANIZATION_LIST_FAILURE";

/**
 * CREATE
 */
export const ORGANIZATION_CREATE = "ORGANIZATION_CREATE";
export const ORGANIZATION_CREATE_SUCCESS = "ORGANIZATION_CREATE_SUCCESS";
export const ORGANIZATION_CREATE_FAILURE = "ORGANIZATION_CREATE_FAILURE";

/**
 * GET BY ID
 */
export const ORGANIZATION_GET = "ORGANIZATION_GET";
export const ORGANIZATION_GET_SUCCESS = "ORGANIZATION_GET_SUCCESS";
export const ORGANIZATION_GET_FAILURE = "ORGANIZATION_GET_FAILURE";

/**
 * UPDATE BY ID
 */
export const ORGANIZATION_UPDATE = "ORGANIZATION_UPDATE";
export const ORGANIZATION_UPDATE_SUCCESS = "ORGANIZATION_UPDATE_SUCCESS";
export const ORGANIZATION_UPDATE_FAILURE = "ORGANIZATION_UPDATE_FAILURE";

/**
 * DELETE BY ID
 */
export const ORGANIZATION_DELETE = "ORGANIZATION_DELETE";
export const ORGANIZATION_DELETE_SUCCESS = "ORGANIZATION_DELETE_SUCCESS";
export const ORGANIZATION_DELETE_FAILURE = "ORGANIZATION_DELETE_FAILURE";